/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiArtifactStreemshotDepthMapFromJSON, StreemApiArtifactStreemshotDepthMapToJSON, StreemApiArtifactStreemshotRevisionFromJSON, StreemApiArtifactStreemshotRevisionToJSON, StreemApiArtifactStreemshotSourceFromJSON, StreemApiArtifactStreemshotSourceToJSON, StreemApiDetectionFromJSON, StreemApiDetectionToJSON, StreemApiNoteFromJSON, StreemApiNoteToJSON, } from './';
export function StreemApiArtifactStreemshotFromJSON(json) {
    return StreemApiArtifactStreemshotFromJSONTyped(json, false);
}
export function StreemApiArtifactStreemshotFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': !exists(json, 'status') ? undefined : json['status'],
        'requestedAt': !exists(json, 'requested_at') ? undefined : (new Date(json['requested_at'])),
        'requestedByUserSid': !exists(json, 'requested_by_user_sid') ? undefined : json['requested_by_user_sid'],
        'requestedByDeviceSid': !exists(json, 'requested_by_device_sid') ? undefined : json['requested_by_device_sid'],
        'fulfilledAt': !exists(json, 'fulfilled_at') ? undefined : (new Date(json['fulfilled_at'])),
        'fulfilledByUserSid': !exists(json, 'fulfilled_by_user_sid') ? undefined : json['fulfilled_by_user_sid'],
        'fulfilledByDeviceSid': !exists(json, 'fulfilled_by_device_sid') ? undefined : json['fulfilled_by_device_sid'],
        'source': !exists(json, 'source') ? undefined : StreemApiArtifactStreemshotSourceFromJSON(json['source']),
        'detections': !exists(json, 'detections') ? undefined : (json['detections'].map(StreemApiDetectionFromJSON)),
        'currentRevision': !exists(json, 'current_revision') ? undefined : StreemApiArtifactStreemshotRevisionFromJSON(json['current_revision']),
        'revisionNumber': !exists(json, 'revision_number') ? undefined : json['revision_number'],
        'note': !exists(json, 'note') ? undefined : StreemApiNoteFromJSON(json['note']),
        'depthMap': !exists(json, 'depth_map') ? undefined : StreemApiArtifactStreemshotDepthMapFromJSON(json['depth_map']),
    };
}
export function StreemApiArtifactStreemshotToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
        'requested_at': value.requestedAt === undefined ? undefined : (value.requestedAt.toISOString()),
        'requested_by_user_sid': value.requestedByUserSid,
        'requested_by_device_sid': value.requestedByDeviceSid,
        'fulfilled_at': value.fulfilledAt === undefined ? undefined : (value.fulfilledAt.toISOString()),
        'fulfilled_by_user_sid': value.fulfilledByUserSid,
        'fulfilled_by_device_sid': value.fulfilledByDeviceSid,
        'source': StreemApiArtifactStreemshotSourceToJSON(value.source),
        'detections': value.detections === undefined ? undefined : (value.detections.map(StreemApiDetectionToJSON)),
        'current_revision': StreemApiArtifactStreemshotRevisionToJSON(value.currentRevision),
        'revision_number': value.revisionNumber,
        'note': StreemApiNoteToJSON(value.note),
        'depth_map': StreemApiArtifactStreemshotDepthMapToJSON(value.depthMap),
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiArtifactStreemshotStatus;
(function (StreemApiArtifactStreemshotStatus) {
    StreemApiArtifactStreemshotStatus["FULFILLED"] = "STATUS_FULFILLED";
    StreemApiArtifactStreemshotStatus["INVALID"] = "STATUS_INVALID";
    StreemApiArtifactStreemshotStatus["REQUESTED"] = "STATUS_REQUESTED";
})(StreemApiArtifactStreemshotStatus || (StreemApiArtifactStreemshotStatus = {}));
//# sourceMappingURL=StreemApiArtifactStreemshot.js.map